// src/modules/calendar/utils/eventEnumeration.js
// Calcula, para cada evento, su posición dentro de la secuencia de su curso/grupo
// (p.ej. "Clase 1 de 6", "Masterclass 2 de 3"). Se usa tanto para pintar la
// etiqueta en las celdas del calendario como para enriquecer la descripción
// del evento (ver eventDescription.js).

// Build enumeration cache: { eventId: { num, total, type, group, cancelled } }
export const buildEnumCache = (allEvents, courses = []) => {
    const cache = {};
    const byCourse = {};
    allEvents.forEach(e => {
        // Skip cancelled events from enumeration
        if (e.status === 'cancelled') {
            cache[e.id] = { num: 0, total: 0, type: (e.resource?.type || e.type) === 'masterclass' ? 'MC' : 'CL', cancelled: true };
            return;
        }
        const cid = e.resource?.courseId || e.courseId || '_none';
        if (!byCourse[cid]) byCourse[cid] = [];
        byCourse[cid].push(e);
    });

    Object.entries(byCourse).forEach(([courseId, evts]) => {
        const course = courses.find(c => c.id === courseId);
        const mcPerGroup = course?.totalMasterclasses || course?.masterclassesPerGroup || 0;
        const clPerGroup = course?.totalSessions || course?.classesPerGroup || 0;

        // Group events by groupNumber first, then by type
        const byGroup = {};
        evts.forEach(e => {
            const gn = e.groupNumber || e.resource?.groupNumber || 1;
            if (!byGroup[gn]) byGroup[gn] = [];
            byGroup[gn].push(e);
        });

        Object.entries(byGroup).forEach(([groupNum, groupEvents]) => {
            const mcEvents = groupEvents
                .filter(e => (e.resource?.type || e.type) === 'masterclass')
                .sort((a, b) => new Date(a.start) - new Date(b.start));
            const clEvents = groupEvents
                .filter(e => (e.resource?.type || e.type) !== 'masterclass')
                .sort((a, b) => new Date(a.start) - new Date(b.start));

            const mcTotal = mcPerGroup > 0 ? mcPerGroup : mcEvents.length;
            const clTotal = clPerGroup > 0 ? clPerGroup : clEvents.length;

            mcEvents.forEach((e, i) => {
                // Use modulo when course defines sessions per group (handles missing groupNumber)
                const num = mcPerGroup > 0 ? ((i) % mcPerGroup) + 1 : i + 1;
                cache[e.id] = { num, total: mcTotal, group: Number(groupNum), type: 'MC' };
            });
            clEvents.forEach((e, i) => {
                const num = clPerGroup > 0 ? ((i) % clPerGroup) + 1 : i + 1;
                cache[e.id] = { num, total: clTotal, group: Number(groupNum), type: 'CL' };
            });
        });
    });
    return cache;
};
